var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Components, CustomElementUtils, PropertyConverters, Watch, } from '@pacem/pacem-core';
import { Pacem2DElement } from './stage';
export class DrawableElement extends Components.PacemCrossItemsContainerElement {
    validate(_) {
        // by default no children allowed (Group will except)
        return false;
    }
    findContainer() {
        // override
        return this.parent || this.stage;
    }
    get stage() {
        return this['_scene'] = this['_scene'] || CustomElementUtils.findAncestorOfType(this, Pacem2DElement);
    }
    get parent() {
        return this['_drawableParent'] = this['_drawableParent'] || CustomElementUtils.findAncestor(this, i => i instanceof DrawableElement);
    }
    disconnectedCallback() {
        delete this['_scene'];
        delete this['_drawableParent'];
        super.disconnectedCallback();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'hide':
                    this.stage?.draw(this);
                    break;
            }
        }
    }
}
__decorate([
    Watch({ emit: false, reflectBack: true, converter: PropertyConverters.String })
], DrawableElement.prototype, "tag", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], DrawableElement.prototype, "inert", void 0);
